import React from 'react';
import PropTypes from 'prop-types';

const AddPhotosDevice = ({
  onClick,
  buttonClassName = 'btn-outline-secondary',
  disabled = false,
}) => {
  return (
    <div className="add-photos-device d-flex flex-column align-items-center justify-content-center">
      <div className="add-photos-device__icon" />
      <p>No photos have been added</p>
      <button
        className={`btn add-photos ${buttonClassName}`}
        onClick={onClick}
        disabled={disabled}>
        Add Photos
      </button>
    </div>
  );
};

AddPhotosDevice.propTypes = {
  onClick: PropTypes.func.isRequired,
  buttonClassName: PropTypes.string,
  disabled: PropTypes.bool,
};

export default AddPhotosDevice;
